export default class RechercheRepertoireModel {
  nom = ""
  prenom = ""
  region = ""
  ville = ""
  langues = []
  sexe = ""
  clienteles = []
  orientationsTheoriques = []
  problematiques = []
  servicesOfferts = []
  secteursDePratique = []
  mediateurAccredite = false
  detenteurAttestationNeuropsy = false
  telepratique = false
  offreSupervision = false
}